import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../FormBase';
import Form from './Form';
import { FIELDS } from './validation/fields';
import { makeInitialState } from '../../../helpers/FormHelper';
import { schema } from './validation/schema';

const PreFormRut = ({ ...props }) => {
  const { mobile, motiveId, issueFormName } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        mobile={mobile}
        title=""
        form={
          <Form
            state={state}
            onData={handleData}
            valid={valid}
            mobile={mobile}
            motiveId={motiveId}
            issueFormName={issueFormName}
          />
        }
        fields={FIELDS}
        pre
        data={data}
        formName="preFormRut"
        schema={schema}
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
      />
    </React.Fragment>
  );
};

PreFormRut.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueFormName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default PreFormRut;
